<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules="[(v) => !!v || 'Title is mandatory']"
					class="fullwidth"
					filled
					label="Title"
					prepend-icon="mdi-file-document"
					required
					v-model="data.title"
				/>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					v-model="data.URL"
					label="URL"
					prepend-icon="mdi-link"
					filled
				/>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
export default {
	name: 'NewsFormExternal',
	props: ['data'],
}
</script>